interface RetornoUsarIdiomaDoNavegador {
  definirIdioma: () => string
  definirIdiomaDoCalendario: () => string
}

export function usarIdiomaDoNavegador(): RetornoUsarIdiomaDoNavegador {
  const idiomasDisponiveisSistema = {
    "pt-BR": "pt-BR",
    "es-CO": "es-CO"
  }

  const idiomasDisponiveisCalendario = {
    "pt-BR": "pt-br",
    "es-CO": "es"
  }

  const definirIdioma = (): string => {
    const idiomaNavegador = navigator.language

    // Adaptação para qualquer idioma que inicia com "es" ser considerado como "es-CO"
    if (idiomaNavegador.startsWith("es")) {
      return idiomasDisponiveisSistema["es-CO"]
    } else {
      return idiomasDisponiveisSistema["pt-BR"]
    }
  }

  const definirIdiomaDoCalendario = (): string => {
    // Vue Calendar necessita de strings específicas para definir o idioma do calendário
    // Navegador || Vue Calendar
    // pt-BR     => pt-br
    // es-CO     => es
    return idiomasDisponiveisCalendario[definirIdioma()]
  }

  return {
    definirIdioma,
    definirIdiomaDoCalendario
  }
}
